import * as React from "react"

import { Provider } from "react-redux"
import { Route, Switch } from "react-router"
import { ConnectedRouter as Router } from "react-router-redux"

import ErrorHandler from "./components/com_error-handler"

import "react-redux-toastr/lib/css/react-redux-toastr.min.css"

import { history, Roles } from "../utils"
import App from "./App"
import Loading from "./components/com_loading"
import { $getMaintenanceState } from "../core/requests"
import { ISupplierInfo } from "../models"

export interface IRootProps {
  store: any
  role: Roles
  managedSupplierList?: ISupplierInfo[]
}

const Root = ({
  store,
  role,
  managedSupplierList,
}: IRootProps): JSX.Element => {
  const routerRender = (props: any) => (
    <App {...props} role={role} managedSupplierList={managedSupplierList} />
  )
  return (
    <ErrorHandler>
      <Provider store={store}>
        <Router history={history}>
          <Route path="/:filter?" render={routerRender} />
        </Router>
      </Provider>
    </ErrorHandler>
  )
}

export default Root
